export default __webpack_public_path__ + "static/media/Group 1820.8b34d864.png";